import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import DocumentsStyles from './Documents.styled';
import ButtonLink from '../Shared/ButtonLink';

const defaultChildren = (
  <>
    <h2>Documents & Forms</h2>
    <p>
      Login to our secure site to print/view your 1098 Tax Form or Payoff Quote
      free of charge. You can also request additional documents. Learn more if
      you want to see all our request options.{' '}
    </p>
    <section className='links'>
      <ButtonLink to='/resources/documents-forms/' appearance='dark'>
        View all documents
      </ButtonLink>
    </section>
  </>
);

const defaultDocuments = [
  'tax forms',
  'COPIES OF TITLE, DEED OF TRUST, & CONTRACT',
  'PAY HISTORY DOCUMENTS',
  'VERIFICATION OF MORTGAGE',
];

const Documents = ({
  children = defaultChildren,
  documents = defaultDocuments,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <DocumentsStyles
      ref={ref}
      className={`block-documents ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <div className='inner'>
        <div className='content'>
          <div className='content-wrapper'>{children}</div>
        </div>
        <div className='examples'>
          <h6 className='no-margin-top color-vmfBlue'>Example documents</h6>

          <ul>
            {documents.map(title => (
              <li key={title}>{title}</li>
            ))}
          </ul>
        </div>
      </div>
    </DocumentsStyles>
  );
};

Documents.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  documents: PropTypes.arrayOf([PropTypes.string]),
  isAnimated: PropTypes.bool,
};

export default Documents;
